/*export function getGoogleMaps() {
  return new Promise(resolve => {
    window.resolveGoogleMapsPromise = () => {
      resolve(window.google);
      delete window.resolveGoogleMapsPromise;
    };
    const script = document.createElement('script');
    const API = 'AIzaSyBrgGGbiHgV4n7ykSNmc8ZpxBv2HIbe2xg';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API}&callback=resolveGoogleMapsPromise`;
    script.async = true;
    document.body.appendChild(script);
  });
}*/

export function getGoogleMaps() {
  return new Promise(resolve => {
    //console.log("called");
    window.resolveGoogleMapsPromise = () => {
      resolve(window.google);
      delete window.resolveGoogleMapsPromise;
      //console.log("deleted");
    };
    const yolo = document.getElementById("googleMapsScript");
    if (yolo === null) {
      //console.log("none with that id yet");
      //console.log(yolo);
      const script = document.createElement("script");
      script.id = "googleMapsScript";
      const API = "AIzaSyBvOJTJVb_y2wUZ1o_ltVSL9elLFXWbBp4";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${API}&callback=resolveGoogleMapsPromise&libraries=visualization`;
      script.async = true;
      // const script2 = document.createElement("script");
      // script2.id = "chartsScript";
      //script2.src = `"text/javascript" src="https://www.gstatic.com/charts/loader.js"`;
      // script2.async = true;
      document.body.appendChild(script);
      //document.body.appendChild(script2);
    } else {
      console.log("found one with that id");
    }
  });
}

export function getLiveGoogleMaps() {
  return new Promise(resolve => {
    window.resolveGoogleMapsPromise = () => {
      resolve(window.google);
      delete window.resolveGoogleMapsPromise;
    };
    const script = document.createElement("scriptLive");
    const API = "AIzaSyBvOJTJVb_y2wUZ1o_ltVSL9elLFXWbBp4";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API}&callback=resolveGoogleMapsPromise`;
    script.async = true;
    document.body.appendChild(script);
  });
}
